import { render, staticRenderFns } from "./PassReq.vue?vue&type=template&id=3f878c4c&scoped=true&"
import script from "./PassReq.vue?vue&type=script&lang=js&"
export * from "./PassReq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f878c4c",
  null
  
)

export default component.exports